import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, tap, throwError } from 'rxjs';
import { ISavedCardDto } from 'src/app/contracts';
import { Api } from 'src/app/core/common/api';
import { IApiOptions, IDisposable } from 'src/app/core/contracts';

@Injectable({ providedIn: 'root' })
export class PaymentCardsData implements IDisposable {
  private api = inject(Api);
  private cards = new BehaviorSubject<ISavedCardDto[]>([]);
  get cards$() {
    return this.cards.asObservable();
  }
  getCards(forceUpdate?: boolean, options?: IApiOptions): Promise<ISavedCardDto[]> {
    return new Promise(resolve => {
      if (forceUpdate || this.cards.getValue().length === 0) {
        this.api
          .get<ISavedCardDto[]>('paymentcards', options)
          .pipe(
            catchError(err => {
              // fallback to current value
              // not calling reject to avoid requiring a 'catch' on callers, especially in loader.ts
              resolve(this.cards.getValue());
              return throwError(() => err as unknown);
            })
          )
          .subscribe((cards: ISavedCardDto[]) => {
            this.cards.next(cards);
            resolve(cards);
          });
      } else {
        resolve(this.cards.getValue());
      }
    });
  }
  setAsDefault(cardId: number) {
    return this.api.update(`paymentcards/${cardId}/default`).pipe(
      tap(() => {
        this.cards.next(
          this.cards.getValue().map(card => ({
            ...card,
            isDefault: card.id === cardId,
          }))
        );
      })
    );
  }
  delete(id: number) {
    return this.api.delete(`paymentcards/${id}`).pipe(
      tap(() => {
        this.cards.next(this.cards.getValue().filter(card => card.id !== id));
      })
    );
  }
  dispose() {
    this.cards.next([]);
    return Promise.resolve();
  }
}
